<p-wrapper
  id="reset-pwd"
  titleWrapper="Réinitialiser le mot de passe"
  [withPreviousButton]="true"
  [goBackLabel]="'Annuler'"
>
  <div body class="px-5">
    <div *ngIf="errorMsg" class="alert alert-danger" role="alert">
      {{ errorMsg }}
    </div>
    <div *ngIf="showMailMsg" class="alert alert-success" role="alert">
      Si votre adresse e-mail est valide, un e-mail avec un code vous a été
      envoyé pour réinitialiser votre mot de passe !
    </div>

    <form
      id="reset-password"
      accept-charset="UTF-8"
      [formGroup]="resetPassForm"
      (ngSubmit)="resetPassword()"
    >
      <p-input
        [formControl]="this.resetPassForm.controls.email"
        id="email"
        type="text"
        label="Adresse e-mail"
        name="email"
        description="Entrer votre adresse e-mail"
        errorMessage="Adresse e-mail obligatoire"
      >
      </p-input>
      <p-input
        [formControl]="this.resetPassForm.controls.validationCode"
        id="otp"
        type="text"
        label="Code de validation"
        name="validationCode"
        description="Entrer le code qui vous a été transmis par mail"
        errorMessage="Code obligatoire"
      >
      </p-input>
      <p-input
        (input)="passwordChanges()"
        [formControl]="this.resetPassForm.controls.newPassword1"
        [type]="resetPasswordInputType"
        [withRightIcon]="true"
        id="new-password"
        type="password"
        label="Mot de passe"
        name="newPassword1"
        description="Entrer votre nouveau mot de passe"
        errorMessage="Mot de passe invalide"
        autocomplete="new-password"
      >
        <span rightIcon (click)="showResetPassword()">
          <i-feather *ngIf="!isResetPasswordDisplayed" name="eye"></i-feather>
          <i-feather
            *ngIf="isResetPasswordDisplayed"
            name="eye-off"
          ></i-feather>
        </span>
      </p-input>

      <div class="container validator">
        <div class="row">
          <div class="col" [ngClass]="styleValidatorNumber">
            &#x2022; <small>Au moins un chiffre</small>
          </div>
          <div class="col" [ngClass]="styleValidatorUppercase">
            &#x2022; <small>Au moins une majuscule</small>
          </div>
        </div>
        <div class="row">
          <div class="col" [ngClass]="styleValidatorLowercase">
            &#x2022; <small>Au moins une minuscule</small>
          </div>
          <div class="col" [ngClass]="styleValidatorSize">
            &#x2022; <small>Au moins 12 caractères</small>
          </div>
        </div>
        <div class="row">
          <div class="col" [ngClass]="styleValidatorSpecial">
            &#x2022; <small>Au moins un caractère spécial</small>
          </div>
        </div>
      </div>

      <p-input
        [formControl]="this.resetPassForm.controls.newPassword2"
        [type]="confirmResetPasswordInputType"
        [withRightIcon]="true"
        id="new-password2"
        type="password"
        label="Confirmation nouveau mot de passe"
        name="newPassword2"
        description="Confirmer votre nouveau mot de passe"
        errorMessage="Mot de passe invalide"
        autocomplete="new-password"
      >
        <span rightIcon (click)="showConfirmResetPassword()">
          <i-feather
            *ngIf="!isConfirmResetPasswordDisplayed"
            name="eye"
          ></i-feather>
          <i-feather
            *ngIf="isConfirmResetPasswordDisplayed"
            name="eye-off"
          ></i-feather>
        </span>
      </p-input>
      <div class="d-flex justify-content-center mt-4">
        <p-button
          id="btn-confirmer"
          label="Confirmer"
          [width]="100"
          [disabled]="!resetPassForm.valid || loading"
          [loading]="loading"
          class="col-5"
        ></p-button>
      </div>
    </form>
  </div>
</p-wrapper>
